import { useUser } from '@/lib/auth';

import { useAiBuilderActiveOperation } from '../stores/AiBuilderSessionProvider';
import {
  type AiGenerateDockGate,
  resolveAiGenerateDockGate,
} from '../utils/aiGenerateDockGate';

import { type AiGenerateDockUsageView } from './useAiGenerateDockUsage';

/** 지금 생성기를 실행할 수 있는가 — 게스트 · AI 채팅 응답 중 · 무료 소진. 판정 순서는 resolveAiGenerateDockGate 가 정한다. */
export const useAiGenerateDockGate = (
  usage: AiGenerateDockUsageView,
): AiGenerateDockGate => {
  const { user } = useUser();
  const activeOperation = useAiBuilderActiveOperation();

  return resolveAiGenerateDockGate({
    isGuest: !user,
    activeOperation,
    quotaExhausted: usage.exhausted,
  });
};
